import { render } from "./FilterOptions.vue?vue&type=template&id=244922b9&scoped=true"
import script from "./FilterOptions.vue?vue&type=script&lang=js"
export * from "./FilterOptions.vue?vue&type=script&lang=js"

import "./FilterOptions.vue?vue&type=style&index=0&id=244922b9&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244922b9"]])

export default __exports__